module.exports = __webpack_public_path__ + "static/media/wall.f7d5850f.jpg";